import { Enum } from "@/commons/enums/Type";

export class PeriodEnum {
  static LAST_SEVEN_DAYS = {
    value: 1,
    jaText: "過去7日間",
    enText: "Last 7 days",
  };
  static LAST_THIRTY_DAYS = {
    value: 2,
    jaText: "過去30日間",
    enText: "Last 30 days",
  };
  static LAST_THREE_MONTHS = {
    value: 3,
    jaText: "過去3ヶ月",
    enText: "Last 3 Months",
  };
  static LAST_MONTH = { value: 4, jaText: "先月", enText: "Last Month" };
  static THIS_MONTH = { value: 5, jaText: "今月", enText: "This Month" };
  static PERIOD_SPECIFICATION = {
    value: 6,
    jaText: "日付指定",
    enText: "Fixed date",
  };

  static getEnum(): PeriodEnumInterface {
  return {
    LAST_SEVEN_DAYS: {
      value: this.LAST_SEVEN_DAYS.value,
      text: this.LAST_SEVEN_DAYS.jaText,
    },
    LAST_THIRTY_DAYS: {
      value: this.LAST_THIRTY_DAYS.value,
      text: this.LAST_THIRTY_DAYS.jaText,
    },
    LAST_THREE_MONTHS: {
      value: this.LAST_THREE_MONTHS.value,
      text: this.LAST_THREE_MONTHS.jaText,
    },
    LAST_MONTH: {
      value: this.LAST_MONTH.value,
      text: this.LAST_MONTH.jaText,
    },
    THIS_MONTH: {
      value: this.THIS_MONTH.value,
      text: this.THIS_MONTH.jaText,
    },
    PERIOD_SPECIFICATION: {
      value: this.PERIOD_SPECIFICATION.value,
      text: this.PERIOD_SPECIFICATION.jaText,
    },
  };
  }

  static getListByLanguage(): Enum[] {
  return [
    {
      value: PeriodEnum.LAST_SEVEN_DAYS.value,
      text: PeriodEnum.LAST_SEVEN_DAYS.jaText,
    },
    {
      value: PeriodEnum.LAST_THIRTY_DAYS.value,
      text: PeriodEnum.LAST_THIRTY_DAYS.jaText,
    },
    {
      value: PeriodEnum.LAST_THREE_MONTHS.value,
      text: PeriodEnum.LAST_THREE_MONTHS.jaText,
    },
    {
      value: PeriodEnum.LAST_MONTH.value,
      text: PeriodEnum.LAST_MONTH.jaText,
    },
    {
      value: PeriodEnum.THIS_MONTH.value,
      text: PeriodEnum.THIS_MONTH.jaText,
    },
    {
      value: PeriodEnum.PERIOD_SPECIFICATION.value,
      text: PeriodEnum.PERIOD_SPECIFICATION.jaText,
    },
  ];
  }
}

export interface PeriodEnumInterface {
  LAST_SEVEN_DAYS: Enum;
  LAST_THIRTY_DAYS: Enum;
  LAST_THREE_MONTHS: Enum;
  LAST_MONTH: Enum;
  THIS_MONTH: Enum;
  PERIOD_SPECIFICATION: Enum;
}
